import { Section } from "../components/Section/Section.jsx";
import { PageHeading } from "../components/PageHeading/PageHeading.jsx";
import "./PlaceholderPage.css";

export function PlaceholderPage({ page }) {
  return (
    <article className="narrow-page placeholder-page">
      <PageHeading>{page.label}</PageHeading>
      <Section heading="Coming next" tone="quiet">
        <p>This workspace is ready for the {page.label.toLowerCase()} experience.</p>
      </Section>
    </article>
  );
}
